import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    data-testid="whatsapp-float-btn"
    href={waLink("Hi GoGoAuto! I'd like to book a mobile service.")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    initial={{ opacity: 0, scale: 0.5, y: 24 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-6 right-6 z-50 group"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-wa-ping" />
    <span className="relative flex items-center justify-center w-16 h-16 rounded-full bg-[#25D366] shadow-[0_8px_32px_rgba(37,211,102,0.45)]">
      <MessageCircle className="w-8 h-8 text-white fill-white" />
    </span>
    <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 whitespace-nowrap bg-white text-obsidian text-sm font-semibold px-4 py-2 rounded-sm shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
      Text us for a quick quote
    </span>
  </motion.a>
);
